module.exports = __webpack_public_path__ + "static/media/bonds.fa7c66a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/bonds.svg
// module id = 347
// module chunks = 21